import React, { createContext, useContext, useState, useEffect } from 'react';

const DoorlyProAuthContext = createContext(null);

export function DoorlyProAuthProvider({ children }) {
  const [partner, setPartner] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('doorlypro_token'));
  const [partnerLoading, setPartnerLoading] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setPartner(payload);
        } else {
          localStorage.removeItem('doorlypro_token');
          setToken(null);
          setPartner(null);
        }
      } catch {
        localStorage.removeItem('doorlypro_token');
        setToken(null);
        setPartner(null);
      }
    }
    setPartnerLoading(false);
  }, [token]);

  const partnerLogin = (newToken) => {
    localStorage.setItem('doorlypro_token', newToken);
    setToken(newToken);
    try {
      const payload = JSON.parse(atob(newToken.split('.')[1]));
      setPartner(payload);
    } catch {
      setPartner(null);
    }
  };

  const partnerLogout = () => {
    localStorage.removeItem('doorlypro_training_progress');
    localStorage.removeItem('doorlypro_token');
    setToken(null);
    setPartner(null);
  };

  return (
    <DoorlyProAuthContext.Provider value={{ partner, token, partnerLogin, partnerLogout, partnerLoading }}>
      {children}
    </DoorlyProAuthContext.Provider>
  );
}

export const useDoorlyProAuth = () => useContext(DoorlyProAuthContext);
